// extracted by mini-css-extract-plugin
export var summary = "submission-zone-module--summary--dphTJ";
export var priceLabel = "submission-zone-module--price-label--KxAfN";
export var price = "submission-zone-module--price--QMyLp";
export var fullPrice = "submission-zone-module--full-price--n7LMj";